<div fxLayout="column">
  <mat-label>
    <h1>Review Application</h1>
  </mat-label>
</div>
<br>
<ng-container>
  <div class="review-page">
    <app-account-ownership
      [reviewState]="reviewState"
      [isInReview]="true"
    ></app-account-ownership>
    <mat-divider></mat-divider>
    <app-account-selection [isInReview]="true"></app-account-selection>
    <mat-divider></mat-divider>
    <!-- app-promo-code [reviewState]="reviewState"></app-promo-code>
    <mat-divider></mat-divider-->
    <app-applicants
      [reviewState]="reviewState"
      (hasCoApplicantEvent)="hasCoApplicant($event)"
      [isInJointMaintenanceFlow]="isInJointMaintenanceFlow"
      (isFormValidEvent)="checkApplicantFormValidity($event)"
    ></app-applicants>
    <app-bsa-profile
      *ngIf="!shouldHideBsaQuestions"
      [reviewState]="reviewState"
      [hasCoApplicant]="applicationHasCoApplicant"
    ></app-bsa-profile>
  </div>
</ng-container>
